// extracted by mini-css-extract-plugin
export var skipAnimation = "_q-0";